import { DIFFERENTIATORS } from "@/lib/brand";

export const WhyChoose = () => {
  return (
    <section
      id="diferenciais"
      data-testid="why-choose-section"
      className="relative py-24 lg:py-36 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#facc15]" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
                Por que a ATL
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
              Seis motivos para confiar cada
              <span className="italic text-[#facc15]"> detalhe</span> à nossa
              equipe.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-base lg:text-lg text-zinc-400 leading-relaxed">
              Da matéria-prima ao acabamento, cada peça que sai da nossa
              fábrica carrega o compromisso com a qualidade. É por isso que
              somos referência em esquadrias de alumínio em{" "}
              <span className="text-white">Florianópolis, São José, Palhoça e Biguaçu</span>.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {DIFFERENTIATORS.map((d) => (
            <article
              key={d.n}
              data-testid={`differentiator-${d.n}`}
              className="group relative p-8 lg:p-10 border-r border-b border-white/10 hover:bg-[#0a0a0a] transition-colors min-h-[260px] flex flex-col"
            >
              <span className="font-display text-5xl text-[#facc15]/40 group-hover:text-[#facc15] transition-colors">
                {d.n}
              </span>
              <h3 className="mt-6 font-display text-xl text-white leading-tight">
                {d.title}
              </h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">
                {d.desc}
              </p>
              <div className="mt-6 h-px w-8 bg-[#facc15] group-hover:w-full transition-all duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
